const editSwitch = {
  label: 'Alerta'
};

export default editSwitch;
